// NotificationItem.js
import moment from 'moment';
import React, { useState } from 'react';
import { NotificationActionTypes } from './NotificationActionTypes';

const NotificationItem = ({ notification, itemClick, onOptionClick, isOptionsOpen, toggleOptions }) => {


    const senderAvatarUrl = notification &&
        notification.sender && notification.sender.profile_image?.thumb_url || '/icons/default-profile-thumb.svg';

    const backgroundColor = notification && notification.viewed
        ? 'transparent'
        : '#DAEDFF';

    // Utility function to format time
    const getMessageTime = (lastUpdatedAtTime) => {
        const updatedAt = moment(lastUpdatedAtTime).local(); // Convert to local time
        let formattedTime = '';

        const onlyMessageDate = updatedAt.clone().startOf('day'); // Set to start of the day
        const currentDate = moment().startOf('day'); // Current date, start of the day

        if (currentDate.isSame(onlyMessageDate, 'day')) {
            // Current Day so display only time
            formattedTime = updatedAt.format('h:mm A'); // Time in custom AM/PM format
        } else if (onlyMessageDate.isAfter(currentDate.clone().subtract(7, 'days'))) {
            formattedTime = updatedAt.format('ddd'); // Day of the week
        } else if (onlyMessageDate.year() === currentDate.year()) {
            formattedTime = updatedAt.format('MMM D'); // Month Day (e.g., Jan 14)
        } else {
            formattedTime = updatedAt.format('MM/DD/YY'); // MM/DD/YY format
        }

        return formattedTime;
    };

    // Handle option click
    const handleOptionClick = (notificationActionType) => {
        onOptionClick(notificationActionType, notification);
        toggleOptions(); // Close the options menu after selection
    };

    return (
        <li className="notification-item" style={{ backgroundColor }} onClick={() => itemClick(notification)}>
            <div className="notification-avatar">
                {/* Placeholder for the avatar image */}
                <img
                    src={senderAvatarUrl}
                    alt="avatar"
                    className="notification-avatar-img"
                />
            </div>

            <div className="notification-content">
                <div className="left-group">
                    <p className="notification-text">{notification.message}</p>
                    <span className="notification-date">{notification.object_meta ? notification.object_meta.subtitle : ''}</span>
                </div>
                <div className="right-group">
                    <span className="notification-time">{getMessageTime(notification.created_at)}</span>
                    <img src="/icons/ellipses-icon-h.svg" alt="More Actions" className="ellipsis-icon" onClick={toggleOptions} />

                    {isOptionsOpen && (
                        <div className="options-menu">
                            <ul>
                                <li onClick={() => handleOptionClick(NotificationActionTypes.DELETE_SINGLE)}>
                                    <img src="/icons/delete-icon-notifications.svg" className="icon" />
                                    Remove this notification
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </li>
    );
};

export default NotificationItem;
